/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon64Regular = forwardRef('ArrowShapeTriangleALeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 12.326c0-4.351-4.814-6.98-8.474-4.626L10.923 27.373c-3.368 2.165-3.368 7.088 0 9.253L41.526 56.3c3.66 2.353 8.474-.275 8.474-4.627V12.326Zm-6.852-2.103c1.664-1.07 3.852.125 3.852 2.103v39.347c0 1.978-2.188 3.173-3.852 2.103L12.545 34.103c-1.53-.985-1.53-3.222 0-4.206l30.603-19.674Z" })));
});
